import { Box, Popover, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { ConflictEmployeeEvent } from '../../../types/Event';
import DrawerLink from '../../common/drawers/ModuleDrawer/DrawerLink';
import { UserConfigurableModule } from '../../../types/User';

export interface ConflictState {
  anchorEl: HTMLElement | null;
  conflicts: ConflictEmployeeEvent[];
}

interface ConflictPopupProps {
  conflictState: ConflictState;
  onClose: () => void;
}

const ConflictPopup: React.FC<ConflictPopupProps> = ({ conflictState, onClose }) => {
  const { anchorEl, conflicts } = conflictState;

  return (
    <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
      <Box sx={{ p: 2, maxWidth: 260 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Conflicting Events
        </Typography>

        {_.map(conflicts, (c) => (
          <Box key={c.event_uuid} sx={{ mb: 1 }}>
            <DrawerLink module={UserConfigurableModule.EVENTS} uuid={c.event_uuid}>
              {c.event_display_name}
            </DrawerLink>
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

export default ConflictPopup;
